import { followUpTimeline } from '@/mocks/homeData';
import SectionHead from './SectionHead';

const typeStyle: Record<string, string> = {
  起: 'bg-primary-500 text-background-50',
  升: 'bg-accent-500 text-secondary-950',
  转: 'bg-secondary-500 text-background-50',
  落: 'bg-background-300 text-foreground-800',
};

export default function FollowUpTimeline() {
  return (
    <section id="timeline" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <SectionHead
          zone="分区 05"
          title="后续追踪时间线"
          desc="按时间顺序还原一个话题的起、升、转、落，方便快速补课，不被单条信息带走。"
          extra={
            <span className="flex items-center gap-2 rounded-md border border-background-300 px-3 py-2 font-label text-xs text-foreground-600">
              <i className="ri-refresh-line text-sm text-primary-500" aria-hidden="true"></i>
              最近更新：今天 09:40
            </span>
          }
        />

        <ol className="relative mt-8 border-l-2 border-background-300 pl-6 md:pl-8">
          {followUpTimeline.map((item, idx) => (
            <li
              key={item.id}
              style={{ animationDelay: `${idx * 70}ms` }}
              className="animate-rise-in relative pb-8 last:pb-0"
            >
              <span
                className={`absolute -left-[31px] top-0 flex h-6 w-6 items-center justify-center rounded-full font-label text-[11px] font-black md:-left-[39px] ${
                  typeStyle[item.type]
                }`}
              >
                {item.type}
              </span>

              <div className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading text-sm font-black text-foreground-950">{item.day}</span>
                  <span className="font-mono text-xs text-foreground-400">{item.time}</span>
                  <span className="rounded-sm bg-background-50 px-2 py-0.5 font-label text-[11px] text-foreground-500">
                    {item.title}
                  </span>
                </div>
                <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}